import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export default function Logs() {
  const { data: liste = [], isLoading, isError } = useQuery({ queryKey: ["admin-logs"], queryFn: async () => (await api.get("/admin/logs")).data, retry: false });
  if (isLoading) return <p className="veri">Yükleniyor…</p>;
  if (isError) return <div className="a-bos">Bu bölümü yalnızca superadmin görebilir.</div>;
  return (
    <div>
      <h1 style={{ fontFamily: "var(--display)", fontSize: 26, marginBottom: 16 }}>İşlem Kayıtları</h1>
      {liste.length === 0 ? <div className="a-bos">Henüz kayıt yok.</div> : (
        <table className="a-tablo">
          <thead><tr><th>Kullanıcı</th><th>İşlem</th><th>Nesne</th><th>Detay</th><th>Zaman</th></tr></thead>
          <tbody>{liste.map((l) => (<tr key={l.id}><td>{l.user}</td><td>{l.action}</td><td>{l.entity}</td><td>{l.detail}</td><td className="sayi">{(l.created_at || "").slice(0, 16).replace("T", " ")}</td></tr>))}</tbody>
        </table>
      )}
    </div>
  );
}
